import lottie from 'lottie-web';
import React, { useEffect, useRef, useState } from 'react';

// import required modules
import { getAppleStoreLink, getAppLinkInBox, isAndroid, isIOS } from '../../../../common/utils/appLinkUtil';
import { toPercentTime, toPercentTimeDesc } from '../../../../common/utils/convertUtil';

export default function liveBox(props) {
  const [liveTab, setLiveTab] = useState(0);
  const hyperLink = useRef(null);
  let [maxPageCount, setMaxPageCount] = useState(0);
  let [result, setResult] = useState(props.data.contents1);


  useEffect(() => {
    const calculateResultList = (contents, shouldReorder = false) => {
      let resultList = contents.map((item) => {
        if (item.url_link?.includes('/live/')) {
          const channelId = item.url_link.split('/').pop().split('#')[0].split('?')[0];
          item.url_link = getAppLinkInBox(
            channelId,
            undefined,
            item.url_link.includes('multiaudio') ? 'multiaudio_normal' : undefined
          );
        }
        return item;
      });

      // 2025 가요대전 썸머 프로그램아이디 2번째 노출 요청 처리
      if (shouldReorder) {
        const pgmTargetIndex = resultList.findIndex(item => item.pgm_id === 'P474781851');
        if (pgmTargetIndex > 0) {
          const pgmItem = resultList.splice(pgmTargetIndex, 1)[0];
          resultList.splice(1, 0, pgmItem);
        }
      }

      return resultList;
    };

    if (liveTab === 0) {
      setMaxPageCount(props.data.contents1.length / 2);
      setResult(calculateResultList(props.data.contents1, true));
    } else {
      setMaxPageCount(props.data.contents2.length / 2);
      setResult(calculateResultList(props.data.contents2));
    }
  }, [liveTab, props.data.contents1, props.data.contents2]);


  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를

  const handleClick = () => {
    let moduleSubTitle;
    let contentTitle;
    let contentId;

    moduleSubTitle = '전체채널';
    contentTitle = '';
    contentId = '';

    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음

    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '', //모듈 아이디 없으면
        moduleTitle: '실시간라이브/24시간TV', //모듈 제목 (Require)
        moduleSubTitle: moduleSubTitle,
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: props.loc_idx, //페이지에서 해당 모듈의 위치
        moduleItemSeq: '', //모듈 내에서 콘텐츠의 위치
        programId: '', //프로그램의 아이디 (추가)
        programTitle: '', //프로그램의 제목 (추가)
        contentId: contentId,//식별자
        contentTitle: contentTitle, //콘텐츠의 제목  (Require)
        contentType: 'L', //콘텐츠의 타입 (별도 표 참조)
      }
    });
  };




  const handleClick_custom = (a, b, c, d) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    let name;
    if (liveTab == 0) {
      name = '라이브전체채널';
    } else {
      name = '24시간TV전체채널';
    }

    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: name,
        clickType: 'NC',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };






  const onClickLink = (link, info, index) => {
    console.log(index)
    //    alert('www== ' + index);
    let moduleSubTitle;
    let contentTitle;
    let contentId;
    let channelname;
    let conver_current_s = (parseInt(index) + 1);
    //alert('liveTab== ' + liveTab);
    let conver_current_s2 = (parseInt(props.loc_idx) + 1);
    //alert('배치에대한컴== ' + conver_current_s2);

    if (liveTab == 0) {
      moduleSubTitle = '실시간라이브';
      contentTitle = info.title;
      contentId = info.channelid;
      channelname = info.channelname;
    } else if (liveTab == 1) {
      moduleSubTitle = '24시간TV';
      contentTitle = info.title;
      contentId = info.channelid;
      channelname = info.channelname;
    }

    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '', //모듈 아이디 없으면
        moduleTitle: '실시간라이브/24시간TV', //모듈 제목 (Require)
        moduleSubTitle: moduleSubTitle,
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: conver_current_s2, //페이지에서 해당 모듈의 위치
        moduleItemSeq: conver_current_s, //모듈 내에서 콘텐츠의 위치
        programId: info.pgm_id, //프로그램의 아이디 (추가)
        programTitle: contentTitle, //프로그램의 제목 (추가)
        contentId: contentId,//식별자
        contentTitle: channelname, //콘텐츠의 제목  (Require)
        contentType: 'L', //콘텐츠의 타입 (별도 표 참조)
      }
    });

    if (isIOS()) {
      // ios 일때

      if (link.indexOf('mode=multiaudio') > -1) {
        alert('멀티 오디오 기능은 안드로이드 기기에서만 지원합니다');
        return;
      }

      let checkAppInstall, clickTimer;
      const eventclearTimers = function () {
        clearInterval(checkAppInstall);
        clearTimeout(clickTimer);
      };

      const intervalCheckHidden = function () {
        if (document.webkitHidden || document.hidden) {
          //console.log('clear - app installed.');
          eventclearTimers();
        }
      };

      checkAppInstall = setInterval(intervalCheckHidden, 200);

      clickTimer = setTimeout(function () {
        if (link.indexOf('sbsplayer://') === 0) {
          window.location = getAppleStoreLink();
        }
      }, 3000);

      window.location = `${link}`;

    } else if (isAndroid()) { // android 일때

      let checkAppInstall, clickTimer;
      const eventclearTimers = function () {
        clearInterval(checkAppInstall);
        clearTimeout(clickTimer);
      };

      const intervalCheckHidden = function () {
        if (document.webkitHidden || document.hidden) {
          //console.log('clear - app installed.');
          eventclearTimers();
        }
      };

      checkAppInstall = setInterval(intervalCheckHidden, 200);

      clickTimer = setTimeout(function () {
        if (link.indexOf('intent://') === 0) {
          window.location = getAppleStoreLink(); //플레이스토어
        }
      }, 3000);

      window.location = `${link}`;
    } else { // android 일때
      window.location = `${link}`;
    }
  };

  // live icon json 
  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector('.icon_live'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'https://static.cloud.sbs.co.kr/libs/lottie/live_icon_ani.json'
    });
  }, []);

  const topContents1 = props.data.contents1[0];
  const topContents2 = props.data.contents2[0];
  const nextContents1 = props.data.contents1_sub[0];
  const nextContents2 = props.data.contents2_sub[0];

  const calculateProgress = (item) => {
    if (!item.starttime || !item.endtime) return null;

    const percent = toPercentTime(item.starttime, item.endtime);
    return percent < 0 || percent > 100 ? null : percent;
  };

  const topContent = liveTab === 0 ? topContents1 : topContents2;
  const nextContent = liveTab === 0 ? nextContents1 : nextContents2;

  const progressPercent = calculateProgress(topContent);
  const progressDesc = progressPercent
    ? toPercentTimeDesc(topContent.starttime, topContent.endtime, progressPercent)
    : '';

  const handleOpenPopupTop = () => {
    //  485 * 928
    const popup = window.open(topContent.talk_link, '타이틀명을 입력하시오', 'top=0, left=0, width=485, height=928, status=no, menubar=no, toolbar=no, resizable=no');
  }

  const normalizedTitle = topContent.title?.replace(/\s+/g, '');

  return (
    <>
      {/* <!-- 화이트 배경 -->*/}
      <div className="mainContents-typeWhite">
        {/* <!-- 실시간라이브, 24시간TV 탭 영역 -->*/}
        <div className="contentsBlock_w">
          <div className="moduleTitleline_w">
            <div className="moduleTitleline_linkType">
              <h2 className="moduleTitleline-Title"><a href="#none" onClick={() => setLiveTab(0)} className={`moduleTitleline-link${liveTab == 0 ? ' current' : ''}`}><span className="icon_live"
              ></span>
                실시간 라이브
              </a></h2>
              <span className="moduleTitleline-Dot"></span>
              <h2 className="moduleTitleline-Title"><a href="#none" onClick={() => setLiveTab(1)} className={`moduleTitleline-link${liveTab == 1 ? ' current' : ''}`}>24시간 TV</a></h2>
            </div>
            <a href={props.data.alllink_url} onClick={(e) => handleClick_custom(e, '', '0', 'all')} className="moduleTitleline-linkMore" style={{ visibility: (props.data.alllink_yn == 'Y' && props.data.alllink_url != '' && props.data.alllink_url != null) ? 'visible' : 'hidden' }}>{props.data.alllink_title}</a>
          </div>

          <div className={"listModule_w_live live" + props.loc_idx}>
            <div className="liveSpotCont_left">
              <div className="moduleBoxWrap_live">
                <a ref={hyperLink} onClick={() => onClickLink(topContent.url_link, topContent, 0)} className="mb_link">
                  <div className="mb_image_w">
                    <div className="mb_image_inner">
                      <img
                        src={
                          liveTab === 0
                            ? (topContent.m_img_url || topContent.img_url)
                            : topContent.img_url
                        }
                        className="mb_image"
                        alt={topContent.title}
                      />
                    </div>
                    <div className="mb_progress_w">
                      <i className="hide">라이브 총시간 및 진행시간</i>
                      <span className="mb_progress" style={{ width: `${progressPercent}%` }}
                        title={progressDesc}></span>
                    </div>
                    <div className="mb_label_w">
                      {(topContent.channelid === 'S17' || topContent.channelid === 'S18') && (
                        <span className="mb_label_bora">보라</span>
                      )}
                    </div>
                  </div>
                  <div className={`mb_cont ${topContent.channelid === 'S01' && normalizedTitle === '방송종료'
                    ? ''
                    : 'active'
                    }`}>
                    <div className="img-con01">
                      <img
                        className="img"
                        src={
                          liveTab === 0
                            ? (topContents1.sum_img || '//image.board.sbs.co.kr/2025/04/24/oiY1745481401179.png')
                            : '//image.board.sbs.co.kr/2025/04/24/oiY1745481401179.png'
                        }
                        alt={topContent.title}
                      />
                      <span className="ico-label05-live">
                        <span className="txt01">라이브</span>
                      </span>
                    </div>
                    <i className="img-con02"></i>
                    <div className="mb_info_w">
                      <strong className="mbif_title">{topContent.title}</strong>
                      {!(topContent.channelid === 'S01' && normalizedTitle === '방송종료') && (
                        <span class="mbif_subinfo"><span class="txt01">{`${topContent.starttime} ~ ${topContent.endtime}`}</span><span class="txt01">{topContent.channelname}</span></span>
                      )}
                    </div>
                  </div>
                </a>
                <div className="moduleBottomBtns">
                  <a href="#none" className="btnType-playtalk" onClick={handleOpenPopupTop}><span className="iconSvg_playtalk"></span><strong className="btnType-title">플레이톡</strong></a>
                </div>
              </div>
              <a
                href={liveTab === 0 ? 'https://www.sbs.co.kr/m/schedule/index.html' : '#none'}
                onClick={(e) => {
                  if (liveTab !== 0) {
                    e.preventDefault(); // 클릭은 되지만 페이지 이동 안 함
                  }
                }}
                className="moduleBoxWrap_next"
              >
                <div className="mb_title_next">다음방송</div>
                <div className="mb_info_w">
                  <span className="mbif_title">{nextContent.title}</span>
                  <span className="mbif_subinfo">{nextContent.starttime} ~ {nextContent.endtime} </span>
                </div>
              </a>
            </div>


            <div className="listModuleSlider listScrollSlider">{/* <!-- mySwiper 클래스 추가시 동작 -->*/}
              {/* <!-- 리스트 -->*/}
              <div className="SliderContent swiper-wrapper">
                {
                  result.slice(1).map((item, index) => {
                    const actualIndex = index + 1;
                    let progressPercent = (item.starttime && item.endtime) ? toPercentTime(item.starttime, item.endtime) : null;
                    progressPercent = (progressPercent > 100 || progressPercent < 0) ? null : progressPercent;
                    const progressDesc = (progressPercent) ? toPercentTimeDesc(item.starttime, item.endtime, progressPercent) : '';

                    const handleOpenPopup = () => {
                      //  485 * 928
                      const popup = window.open(item.talk_link, '타이틀명을 입력하시오', 'top=0, left=0, width=485, height=928, status=no, menubar=no, toolbar=no, resizable=no');
                    }

                    return (
                      <div className="listModuleItem swiper-slide">
                        <div className="moduleBoxWrap_live">
                          <a ref={hyperLink} onClick={() => onClickLink(item.url_link, item, actualIndex)} className="mb_link">
                            <div className="mb_image_w">
                              <div className="mb_image_inner">
                                <img src={item.img_url} className="mb_image" alt={item.title + ' ' + item.channelname} />
                              </div>
                              <div className="mb_progress_w">
                                <i className="hide">라이브 총시간 및 진행시간</i>
                                <span className="mb_progress" style={{ width: `${progressPercent}%` }} title={progressDesc}></span>
                              </div>
                              <div className="mb_label_w">
                                {(item.channelid === 'S17' || item.channelid === 'S18') && (item.bora_yn === 'Y') ? (
                                  <span className="mb_label_bora">보라</span>
                                ) : ''}
                              </div>
                            </div>
                            <div className="mb_info_w">
                              <span className="mbif_title">{item.title}</span>
                              <span className="mbif_subinfo">{item.channelname}</span>
                            </div>
                          </a>
                          {/* <div className="moduleBottomBtns">
                            <a href="#none" onClick={handleOpenPopup} className="btnType-playtalk">
                              <span className="iconSvg_playtalk"></span>
                              <strong className="btnType-title">플레이톡</strong>
                            </a>
                          </div> */}
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>
          </div>
        </div >
      </div >
    </>
  );
}